import { useNormalizedPublishedTime } from '@libs/getNormalizedPublishedTime'
import { postLike } from '@app-core/profile/actions'
import appUrl, { imageUrl } from '@libs/appUrl'
import { useDispatch } from 'react-redux'
import { trackUserProfileArticleListEnterArticle } from '@libs/eventTracking/profile/user-profile.article-list.enter-article'

const coverImageFallbackSrc = '/images/articleCardImagePlaceholder.svg'
const avatarImageFallbackSrc = imageUrl('/img/head2.png')

const getTitle = (article) => {
  const { type = '', web = {} } = article
  const isWeb = type === 'web' || type === 'pugc'
  const title = isWeb ? web.title : article.title || ''
  return title
}

const getImage = (article) => {
  const { img } = article

  // 一般文章沒有照片，顯示女孩照片
  if (!(img.length > 0)) {
    return {
      w: 1560,
      h: 820,
      thumb: coverImageFallbackSrc,
    }
  }

  return img[0]
}

const getUserAvatar = (article) => {
  // 大頭貼沒照片，顯示女孩照片
  return article?.userInfo?.img ? imageUrl(article?.userInfo?.img) : avatarImageFallbackSrc
}

const useGetArticleCardInfo = ({ article }) => {
  const { t, isLike, userInfo, postID, like } = article
  const dispatch = useDispatch()

  const title = getTitle(article)
  const coverImage = getImage(article)
  const { dateTime, formatted } = useNormalizedPublishedTime(t)
  const handleClickLike = () => dispatch(postLike({ postID, isLike: isLike === 0 ? 1 : 0 }))
  const avatar = getUserAvatar(article)

  const postLink = `${appUrl.myhost}/${postID.replace(/\./g, '/')}`

  const handleArticleClick = (e) => {
    e.preventDefault()

    trackUserProfileArticleListEnterArticle({
      currentPage: {
        pageName: 'user-profile',
      },
      toPage: {
        pageUrl: postLink,
        pageName: 'article',
      },
      actionTarget: postID,
    })

    if (window.RNApp && window.RNApp.webview) {
      window.RNApp.webview(postLink)
    } else {
      window.open(postLink)
    }
  }

  return {
    dateTime,
    formatted,
    coverImage,
    userInfo,
    handleClickLike,
    avatar,
    title,
    postID,
    isLike,
    like,
    postLink,
    coverImageFallbackSrc,
    avatarImageFallbackSrc,
    handleArticleClick,
  }
}

export default useGetArticleCardInfo
